module.exports = __webpack_public_path__ + "img/dia-muertos-2025.f744738e.jpg";